<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "UserItem" });
import * as API from "../../services/api.js";
import { USER_STORE } from "../../services/store.js";
export let key;
export let onError = void 0;
const fetchUser = (key2) => {
    if (key2 === void 0) {
        return;
    }
    void API.fetchUser({ userKey: key2 }, onError);
};
$: fetchUser(key);
</script>

{#if key !== undefined && key in $USER_STORE }

    <slot user = { $USER_STORE[key] }>

        <pre>{ JSON.stringify($USER_STORE[key], null, 4) }</pre>

    </slot>

{/if}